import { api } from '../index';

export const addAccessForEmployee = data => api.post('/multi-access/add', data);

export const getMultiAccessEmployeesList = companyId => api.get(`multi-access/${companyId}/list`);

export const deleteEmployeeMultiAccess = accessId => api.post(`multi-access/${accessId}/destroy`);
